import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AvailableRooms, Booking } from '../services/api';

export interface GuestListFilters {
  date?: string;
  name?: string;
  phone?: string;
  email?: string;
  status?: string;
}

interface GuestListState {
  guests: Booking[];
  loading: boolean;
  roomAvail: Record<string, string[]> | null;
  roomAvailDate: string;
  roomAvailLoading: boolean;
}

const initialState: GuestListState = {
  guests: [],
  loading: true,
  roomAvail: null,
  roomAvailDate: '',
  roomAvailLoading: false,
};

const guestListSlice = createSlice({
  name: 'guestList',
  initialState,
  reducers: {
    resetGuestListState: () => initialState,
    fetchGuestsRequest: (state, _action: PayloadAction<GuestListFilters>) => {
      state.loading = true;
    },
    fetchGuestsSuccess: (state, action: PayloadAction<Booking[]>) => {
      state.guests = action.payload;
      state.loading = false;
    },
    fetchGuestsFailure: (state) => {
      state.loading = false;
    },
    fetchRoomAvailabilityRequest: (state, _action: PayloadAction<string>) => {
      state.roomAvailLoading = true;
    },
    fetchRoomAvailabilitySuccess: (state, action: PayloadAction<{ date: string; data: AvailableRooms }>) => {
      state.roomAvail = action.payload.data.available;
      state.roomAvailDate = action.payload.date;
      state.roomAvailLoading = false;
    },
    fetchRoomAvailabilityFailure: (state) => {
      state.roomAvail = null;
      state.roomAvailLoading = false;
    },
    clearRoomAvailability: (state) => {
      state.roomAvail = null;
      state.roomAvailDate = '';
      state.roomAvailLoading = false;
    },
  },
});

export const guestListActions = guestListSlice.actions;
export const selectGuestListGuests = (state: { guestList: GuestListState }) => state.guestList.guests;
export const selectGuestListLoading = (state: { guestList: GuestListState }) => state.guestList.loading;
export const selectRoomAvailability = (state: { guestList: GuestListState }) => state.guestList.roomAvail;
export const selectRoomAvailabilityDate = (state: { guestList: GuestListState }) => state.guestList.roomAvailDate;
export const selectRoomAvailabilityLoading = (state: { guestList: GuestListState }) => state.guestList.roomAvailLoading;

export default guestListSlice.reducer;
